import { Shimmer } from '@fluentui/react';
import { times } from 'lodash';

/**
 * Shimmer for the search filter.
 */
export const SearchFilterShimmer = ({ length = 6 }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'stretch' }}>
    <Shimmer
      style={{
        padding: '0.5em',
      }}
      width='12em'
    />
    {shimmerElements(length)}
    <Shimmer
      style={{
        padding: '0.5em',
      }}
      width='12em'
    />
    <div style={{ flexGrow: 2 }} />
    <Shimmer
      style={{
        padding: '0.5em',
      }}
      width='4em'
    />
  </div>
);

/**
 * Function that creates n number of shimmer elements based on the supplied length.
 */
const shimmerElements = (length = 5) =>
  times(length, i => (
    <Shimmer
      style={{
        padding: '0.5em',
        minWidth: `${5 + (i % 3)}em`,
      }}
      key={`filter-shimmer${i}`}
    />
  ));
